import { useSearchParams, Navigate } from "react-router-dom";
import { ShieldAlert, LogIn } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { usePageMeta } from "@/components/site/Reveal";

export default function Login() {
  usePageMeta(
    "Employee Login — SKN Group of Companies",
    "Employee access to the SKN Group portal. Restricted to SKN Group employees."
  );
  const { user, loading, login } = useAuth();
  const [searchParams] = useSearchParams();
  const error = searchParams.get("error");

  if (!loading && user) return <Navigate to="/portal" replace />;

  return (
    <div className="min-h-screen flex items-center justify-center px-6 pt-20" data-testid="login-page">
      <div className="max-w-md w-full border border-foreground/15 p-10 md:p-14 bg-card">
        <p className="text-xs uppercase tracking-[0.3em] text-[#B8997A]">Employee Access</p>
        <h1 className="mt-4 font-display text-3xl md:text-4xl font-medium tracking-tight">
          SKN Group <span className="italic bronze">Portal</span>
        </h1>
        <p className="mt-4 text-sm text-muted-foreground leading-relaxed">
          Sign in with your SKN Group Google account. Access is restricted to
          employees with an <span className="font-medium text-foreground">@skngroup.net</span> address.
        </p>

        {error === "restricted" && (
          <div
            className="mt-6 flex items-start gap-3 border border-destructive/40 bg-destructive/5 p-4"
            data-testid="login-restricted-message"
          >
            <ShieldAlert size={18} className="text-destructive shrink-0 mt-0.5" strokeWidth={1.5} />
            <p className="text-sm text-destructive">
              Access restricted to SKN Group employees. Please sign in with your
              @skngroup.net account.
            </p>
          </div>
        )}
        {error === "failed" && (
          <div
            className="mt-6 border border-destructive/40 bg-destructive/5 p-4"
            data-testid="login-failed-message"
          >
            <p className="text-sm text-destructive">Sign-in failed. Please try again.</p>
          </div>
        )}

        <button
          onClick={login}
          data-testid="google-login-button"
          className="mt-8 w-full inline-flex items-center justify-center gap-2 bg-foreground text-background px-8 py-4 text-sm font-medium hover:bg-[#B8997A] hover:text-[#0B0F14] transition-colors duration-300"
        >
          <LogIn size={16} strokeWidth={1.5} /> Sign in with Google
        </button>
      </div>
    </div>
  );
}
